export const Constant = {
  Role: {
    ADMIN: "admin",
    SUB_ADMIN: "sub-admin",
    CUSTOMER: "customer",
    WORKER: "worker",
  },
};
